import { mapGetters } from 'vuex';
import ACLService from '../services/ACLService';

export default {
  data() {
    return {
      ACLService: null
    };
  },
  computed: {
    ...mapGetters('auth', ['permissions']),
    acl() {
      return new ACLService(this.permissions);
    }
  },
  methods: {
    checkParentPermissions(item) {
      return this.acl.checkParentPermissions(item);
    },
    hasPermissions(permissions) {
      return this.acl.hasPermissions(permissions);
    },
    hasPermission(name, permission) {
      return this.acl.hasPermission(name, permission);
    },
    checkPermission(item) {
      return this.acl.checkPermission(item);
    }
  }
};
